/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, NlpIntegrationGetLiveTopicsStationSettingsPathParams, NlpIntegrationGetLiveTopicsStationSettings401, NlpIntegrationGetLiveTopicsStationSettings403 } from "../models/NlpIntegrationGetLiveTopicsStationSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { nlpIntegrationGetLiveTopicsStationSettings } from "../axios/nlpIntegrationGetLiveTopicsStationSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const nlpIntegrationGetLiveTopicsStationSettingsQueryKey = (entityId: NlpIntegrationGetLiveTopicsStationSettingsPathParams["entityId"]) => ["api-v2", { url: '/nlp-integration/v1/live-topics/station-settings/:entityId', params: {entityId:entityId} }] as const

export type NlpIntegrationGetLiveTopicsStationSettingsQueryKey = ReturnType<typeof nlpIntegrationGetLiveTopicsStationSettingsQueryKey>

export function nlpIntegrationGetLiveTopicsStationSettingsQueryOptions(entityId: NlpIntegrationGetLiveTopicsStationSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = nlpIntegrationGetLiveTopicsStationSettingsQueryKey(entityId)
        return queryOptions<NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, ResponseErrorConfig<NlpIntegrationGetLiveTopicsStationSettings401 | NlpIntegrationGetLiveTopicsStationSettings403>, NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, typeof queryKey>({
         enabled: !!(entityId),
         queryKey,
         queryFn: async ({ signal }) => {
            return nlpIntegrationGetLiveTopicsStationSettings(entityId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Every setting is resolved to its effective value, taking the station's own value when present, then the inherited value, then the built-in default. Only settings available to API clients are included.
 * @summary Get the effective settings of a station
 * {@link /nlp-integration/v1/live-topics/station-settings/:entityId}
 */
export function useNlpIntegrationGetLiveTopicsStationSettings<TData = NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, TQueryData = NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, TQueryKey extends QueryKey = NlpIntegrationGetLiveTopicsStationSettingsQueryKey>(entityId: NlpIntegrationGetLiveTopicsStationSettingsPathParams["entityId"], options: 
{
  query?: Partial<QueryObserverOptions<NlpIntegrationGetLiveTopicsStationSettingsQueryResponse, ResponseErrorConfig<NlpIntegrationGetLiveTopicsStationSettings401 | NlpIntegrationGetLiveTopicsStationSettings403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? nlpIntegrationGetLiveTopicsStationSettingsQueryKey(entityId)
         

         const query = useQuery({
          ...nlpIntegrationGetLiveTopicsStationSettingsQueryOptions(entityId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<NlpIntegrationGetLiveTopicsStationSettings401 | NlpIntegrationGetLiveTopicsStationSettings403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}